/**
 * @generated SignedSource<<be8c44539617a08a025b1a03b8dde574>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemTileBase_viewer$data = {
  readonly noReserveLabelSearchBrowseFF: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"Price_viewer" | "Shipping_viewer">;
  readonly " $fragmentType": "ItemTileBase_viewer";
};
export type ItemTileBase_viewer$key = {
  readonly " $data"?: ItemTileBase_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemTileBase_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemTileBase_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Shipping_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Price_viewer"
    },
    {
      "alias": "noReserveLabelSearchBrowseFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "noReserveLabelSearchBrowse"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"noReserveLabelSearchBrowse\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a8129d11dd137ec926fbff8c88986104";

export default node;
